import { $, $$, alcance, aviso, avisoHtml, cajaDelActo, esc, limpiar, misCajas, noContesto, noHabilitado, num, pedir, puede, puedoActo, rpc, sb } from './nucleo';
import { cargarCaja } from './caja';
import { abrirAnulacion } from './cobros';

// =====================================================================
//  Las rendiciones · lo del cajero 2, en la pestaña de Caja
// =====================================================================
//  A ciegas, igual que el arqueo: la pantalla NO dice cuánto tendría que
//  traer hasta que el cajero escribió lo que contó. Contar no puede ser
//  copiar un número que ya estaba en la pantalla.

let A_RENDIR = [], E_A_RENDIR = '', E_HECHAS = '';
//  Los cobros de la calle que todavía no se rindieron, CON su monto: son los de
//  la tarjeta plegada «Corregir un cobro de la calle» (D182).
let A_CORREGIR = [], E_CORREGIR = '';
//  LO QUE SE VE RECORTADO. Las dos vistas tienen el permiso pero ven MENOS
//  (`vuelta.ver` en `propio`, sólo pedidos visibles): un permiso suelto como
//  `rendicion.recibir` en un motoquero lo deja mirando un recorte, y
//  «Ninguna moto tiene plata» sería plata en la calle declarada inexistente.
//  La pantalla dice de quién puede hablar (D107).
let RECORTE_AR: string[] = [], RECORTE_HE: string[] = [];

//  «1 cobro», «3 cobros»: la gente lee el número, no un «cobro(s)» (D181).
const nCobros = (n: number) => `${n} cobro${n === 1 ? '' : 's'}`;
const recortan = (...claves: string[]) =>
  claves.filter(k => {
    const [r, a] = k.split('.');
    return puede(r, a) && alcance(r, a) !== 'todos';
  });
const avisoRecorte = (que: string, claves: string[]) =>
  `Ves ${que} sólo en parte: tu <b>${claves.join('</b> y tu <b>')}</b> no ` +
  `alcanza${claves.length > 1 ? 'n' : ''} a todos. Lo que falta puede existir igual.`;
//  Qué permiso le falta a quien mira, de los que hacen falta para esa lectura.
//  Se mide sobre la DEFINICIÓN de cada vista (D84): `v_cobros_a_rendir` sale
//  de `pedido_pagos` y `vueltas` (`pedido.ver`, `vuelta.ver`); `v_rendiciones`
//  suma un JOIN a `cajas` (`caja.ver`). Ojo: un permiso que falta llega como
//  lista vacía, no como error (regla 5), y "no hay ninguna" acá es una
//  afirmación carísima.
const faltan = (...claves: string[]) =>
  claves.filter(k => !puede(k.split('.')[0], k.split('.')[1]));
const motivoR = (e: string, que: string, sinPermiso: string[]) =>
  sinPermiso.length
    ? `No podés ver ${que}: te falta <b>${sinPermiso.join('</b> y <b>')}</b>.`
    : e ? `No se pudieron leer ${que} (${esc(e)}).` : '';

export async function cargarRendiciones(){
  if (!puede('rendicion','recibir')) return;
  limpiar('#rendirMsg');
  const nada = () => Promise.resolve({ data: null, error: null });
  const faltaAr = faltan('vuelta.ver', 'pedido.ver');
  const faltaHe = faltan('vuelta.ver', 'caja.ver');
  RECORTE_AR = recortan('vuelta.ver', 'pedido.ver');
  RECORTE_HE = recortan('vuelta.ver');
  const [ ar, he, co ] = await Promise.all([
    faltaAr.length ? nada() : pedir(sb.from('v_cobros_a_rendir').select('*').order('motoquero')),
    faltaHe.length ? nada()
      : pedir(sb.from('v_rendiciones').select('*').order('ocurrido_en', { ascending: false }).limit(30)),
    //  Los mismos cobros que `v_cobros_a_rendir` suma, de a uno: de la calle, sin
    //  rendir, vivos. `v_cobros` sale de `pedido_pagos` (`pedido.ver`, D84).
    faltaAr.length ? nada()
      : pedir(sb.from('v_cobros').select('*').not('vuelta_id', 'is', null)
          .is('rendicion_id', null).eq('anulado', false).eq('es_anulacion', false)
          .order('ocurrido_en')),
    //  La rendición entra siempre en la caja `rendicion.caja`, y
    //  `recibir_rendicion` exige estar habilitado en ella (0031); cuál es lo
    //  contesta la base (D93). Va DENTRO del `Promise.all`: en serie, la espera
    //  con la red caída se suma a las otras dos.
    misCajas()
  ]);
  E_A_RENDIR = motivoR(ar.error?.message || '',
    'los cobros que las motos tienen que rendir', faltaAr);
  E_HECHAS   = motivoR(he.error?.message || '', 'las rendiciones ya hechas', faltaHe);
  A_RENDIR = ar.data || [];
  E_CORREGIR = motivoR(co?.error?.message || '', 'los cobros de la calle', faltaAr);
  A_CORREGIR = co?.data || [];
  pintarRendir();
  pintarCorregir();
  pintarRendicionesHechas(he.data || []);
}

function pintarRendir(){
  //  Un bloque por motoquero. Las monedas salen de lo que trajo, pero el
  //  monto NO se muestra: es justo lo que se está por contar.
  type Moto = { nombre: string; dias: number;
                monedas: { id: number; codigo: string; cobros: number }[] };
  const porMoto: Record<string, Moto> = {};
  A_RENDIR.forEach(r => {
    (porMoto[r.motoquero_id] ??= { nombre: r.motoquero, dias: 0, monedas: [] });
    porMoto[r.motoquero_id].monedas.push({ id: r.moneda_id, codigo: r.moneda, cobros: r.cobros });
    porMoto[r.motoquero_id].dias = Math.max(porMoto[r.motoquero_id].dias, Number(r.dias || 0));
  });

  const bloques = Object.entries(porMoto).map(([id, m]) => `
    <div class="confirmar">
      <div class="conf-tit">${esc(m.nombre)}
        ${m.dias > 0 ? `<span class="chip c-warn">lo más viejo, de hace ${m.dias} ${Number(m.dias) === 1 ? 'día' : 'días'}</span>` : ''}</div>
      <p class="conf-txt"><b>Contá la plata y escribí lo que contaste.</b>
         Trajo ${m.monedas.map(x => esc(x.codigo)).join(' y ')}
         (${nCobros(m.monedas.reduce((a,x) => a + x.cobros, 0))}).</p>
      <div class="grid g3">
        ${m.monedas.map(x => `
          <label>${esc(x.codigo)} contados
            <input type="number" step="0.01" min="0" class="reInput"
                   data-moto="${id}" data-moneda="${x.id}"></label>`).join('')}
        <label>Nota <span class="hint">opcional</span>
          <input type="text" class="reNota" data-moto="${id}"></label>
      </div>
      <div class="fila-acc" style="margin-top:0.588rem">
        <button class="b b-pri reBtn" data-moto="${id}">Recibir la rendición</button>
      </div>
    </div>`).join('');

  //  "Ninguna moto tiene plata para rendir" sólo se dice cuando la lectura contestó.
  const recorte = RECORTE_AR.length
    ? `<p class="hint">${avisoRecorte('los cobros que las motos tienen que rendir', RECORTE_AR)}</p>` : '';
  $('#rendirLista').innerHTML = E_A_RENDIR
    ? `<div class="vacio">${E_A_RENDIR}</div>`
    : recorte + (bloques || (RECORTE_AR.length
        ? '<div class="vacio">Ninguna moto que vos puedas ver tiene plata para rendir.</div>'
        : '<div class="vacio">Ninguna moto tiene plata para rendir.</div>'));

  //  Habilitación por caja (D48, D93): se saca el BOTÓN, no la lista. Sólo
  //  cuando la base contestó que no: con `mis_cajas` caída se ofrece y contesta ella.
  if (puedoActo('rendicion') === false){
    $$('#rendirLista .reBtn').forEach(b => b.remove());
    if (bloques) avisoHtml('#rendirMsg','warn',
      noHabilitado(cajaDelActo('rendicion'), 'recibir la rendición en') +
      ' Lo de arriba es lo que hay para rendir; tomarla la tiene que hacer ' +
      'alguien habilitado en esa caja.');
  }

  $$('#rendirLista .reBtn').forEach(b => b.onclick = () => rendir(b.dataset.moto, b));
}

async function rendir(motoId, btn){
  limpiar('#rendirMsg');
  const inputs = [...$$(`.reInput[data-moto="${motoId}"]`)];
  const vacio = inputs.find(i => i.value === '' || isNaN(Number(i.value)));
  if (vacio) return aviso('#rendirMsg','bad',
    'Escribí lo que contaste en cada moneda, aunque sea cero. Cero también es un dato.');

  const montos = inputs.map(i => ({ moneda_id: Number(i.dataset.moneda), declarado: Number(i.value) }));
  const nota = $(`.reNota[data-moto="${motoId}"]`)?.value.trim() || null;

  btn.disabled = true;
  const { data, error } = await rpc('recibir_rendicion', {
    p_motoquero_id: Number(motoId), p_montos: montos, p_pagos: null, p_notas: nota });
  //  Una rendición que no contestó quizá quedó recibida, y repetirla crea otra
  //  con los mismos montos: el botón no vuelve (D91, D92).
  if (!noContesto(error)) btn.disabled = false;
  if (error) return aviso('#rendirMsg','bad', error.message);

  //  Recién ahora se dice cuánto se esperaba, y de a una moneda: es el
  //  momento en que el número deja de poder influir en el conteo.
  const detalle = (data?.detalle || []).map(d =>
    `${esc(d.moneda)}: esperaba ${num(Number(d.esperado))}, trajo ${num(Number(d.declarado))}` +
    (d.diferencia === null || d.diferencia === undefined ? ' — no se pudo comparar'
      : Number(d.diferencia) === 0 ? ' — cuadra'
      : ` — ${Number(d.diferencia) < 0 ? 'faltan' : 'sobran'} ${num(Math.abs(Number(d.diferencia)))}`)).join('<br>');

  await cargarRendiciones();
  //  avisoHtml y no aviso: `detalle` es una lista separada por <br>. Cada
  //  dato que viene de la base ya se escapó al armarla, arriba.
  avisoHtml('#rendirMsg', data?.desvios ? 'bad' : 'ok',
    `${esc(data?.mensaje || 'Rendición tomada.')}<br>${detalle}`);
  cargarCaja();
}

//  CORREGIR UN COBRO DE LA CALLE (D182): por moto, los cobros que todavía no
//  rindió, con su monto y un «Anular» que abre la misma fila de confirmación que
//  los cobros del pedido. Va plegado: abrirlo es dejar de contar a ciegas.
function pintarCorregir(){
  limpiar('#corregirMsg');
  if (E_CORREGIR){ $('#corregirLista').innerHTML = `<div class="vacio">${E_CORREGIR}</div>`; return; }
  const porMoto: Record<string, any[]> = {};
  //  Sin `vuelta.ver` el motoquero llega null (D84): se agrupa por vuelta, para
  //  no juntar dos motos que no se ven bajo un mismo título.
  A_CORREGIR.forEach(c => (porMoto[c.motoquero_id ?? 'v' + c.vuelta_id] ??= []).push(c));
  $('#corregirLista').innerHTML = Object.values(porMoto).map(cs => `
    <div class="conf-tit" style="margin-top:0.588rem">${esc(cs[0].motoquero ?? 'Una moto que no podés ver')}</div>
    <div class="tw"><table class="t-tarjetas">
      <thead><tr><th>Cuándo</th><th>Pedido</th><th>Cliente</th><th class="num">Monto</th>
                 <th>Quién cargó</th><th></th></tr></thead>
      <tbody>${cs.map(c => `
        <tr data-cobrofila="${c.id}">
          <td class="hint">${new Date(c.ocurrido_en).toLocaleString('es-AR')}</td>
          <td class="mono">${esc(c.pedido)}</td>
          <td>${esc(c.cliente ?? '—')}</td>
          <td class="num">${esc(c.moneda)} ${num(Number(c.monto))}</td>
          <td>${esc(c.cobro ?? '—')}</td>
          <td><button class="b b-sec" data-anular="${c.id}">Anular</button></td>
        </tr>`).join('')}</tbody></table></div>`).join('')
    || `<div class="vacio">${RECORTE_AR.length
         ? 'Ninguna moto que vos puedas ver tiene cobros sin rendir.'
         : 'Ninguna moto tiene cobros sin rendir.'}</div>`;
  $$('#corregirLista [data-anular]').forEach(b => b.onclick = () => {
    const c = A_CORREGIR.find(k => k.id === Number(b.dataset.anular));
    if (c) abrirAnulacion(c, { fila: b.closest('tr'), columnas: 6, alListo: async m => {
      //  Lo que la moto tiene que rendir cambió: se vuelve a leer todo.
      await cargarRendiciones();
      aviso('#corregirMsg','ok', m);
    }});
  });
}

function pintarRendicionesHechas(rs){
  if (E_HECHAS){
    $('#tblRendiciones').innerHTML =
      `<tr><td colspan="7" class="vacio">${E_HECHAS}</td></tr>`;
    return;
  }
  //  `rendicion_montos` entra por LEFT JOIN: sin montos, `esperado`,
  //  `declarado` y `diferencia` vienen null. Ojo: `Number(null)` es 0, y eso
  //  pintaría un cero contado y el chip <b>cuadra</b> sin haber leído nada.
  //  Preguntar por null ANTES de comparar, como el arqueo de `caja.ts` (D83).
  const cifra = (v: unknown) => v === null || v === undefined
    ? '<span class="hint">no se sabe</span>' : num(Number(v));
  $('#tblRendiciones').innerHTML = rs.map(r => `
    <tr>
      <td class="hint">${new Date(r.ocurrido_en).toLocaleString('es-AR')}</td>
      <td>${esc(r.motoquero)}</td>
      <td class="mono">${esc(r.moneda || '—')}</td>
      <td class="num">${cifra(r.esperado)}</td>
      <td class="num">${cifra(r.declarado)}</td>
      <td class="num">${r.diferencia === null || r.diferencia === undefined
        ? '<span class="chip c-warn">sin montos cargados</span>'
        : Number(r.diferencia) === 0
        ? '<span class="chip c-ok">cuadra</span>'
        : `<span class="chip c-bad">${num(Number(r.diferencia))}</span>`}</td>
      <td>${esc(r.recibido_por || '—')}</td>
    </tr>`).join('') || `<tr><td colspan="7" class="vacio">${RECORTE_HE.length
      ? 'Ninguna que vos puedas ver' : 'Todavía ninguna'}</td></tr>`;
  //  Y con filas también: las que faltan son de otros motoqueros.
  if (RECORTE_HE.length) $('#tblRendiciones').insertAdjacentHTML('beforeend',
    `<tr><td colspan="7" class="hint">${avisoRecorte('las rendiciones', RECORTE_HE)}</td></tr>`);
}
